// extracted by mini-css-extract-plugin
module.exports = {"stars":"stars_stars__2WAnK"};